module.exports = __webpack_public_path__ + "images/emoji/page_with_curl.4db5434e631be2097f88.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/page_with_curl.png
// module id = GAvB
// module chunks = 13